import {Component, OnInit, ViewChild} from '@angular/core';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {IpProfileApiService} from '../../services/api/network/online/ip-profile/ip-profile-api.service';
import {SnackBarService} from '../../services/common/snack-bar/snack-bar.service';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {LogicalConjunctionService} from '../../services/common/logical-conjunction/logical-conjunction.service';
import {MatDialog} from '@angular/material/dialog';
import * as _ from 'lodash';
import {ConfirmationDialogComponent} from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {IpProfileDialogComponent} from './ip-profile-dialog/ip-profile-dialog.component';
import {ActivatedRoute} from '@angular/router';
import {TableColumnsConfigurationDialogComponent} from '../../dialogs/table-columns-configuration-dialog/table-columns-configuration-dialog.component';
import {DefaultIpProfilePipe} from './default-ip-profile.pipe';
import {ArmTableComponent} from '../../components/arm-table/arm-table.component';
import {LoaderService} from '../../services/common/loader-service/loader.service';

@Component({
  selector: 'ip-profiles',
  templateUrl: './ip-profiles.component.html',
  styleUrls: ['./ip-profiles.component.scss']
})
export class IpProfilesComponent implements OnInit {

  isUnauthorized: boolean;
  items = [];
  ipProfileDefinition;
  isMultipleSelection: false;
  selection;
  filter;

  @ViewChild(ArmTableComponent) armTable;

  displayedColumns: Array<DisplayedColumnInf> = [
    { name: 'name', display: 'Name', selected: true, transformer: DefaultIpProfilePipe, width: 400},
    { name: 'sbcMediaSecurityMode', display: 'SBC Media Security Mode', selected: true, width: 200 },
    { name: 'sbcRemote3xxBehavior', display: 'Remote 3xx Mode', selected: true, width: 200 },
    { name: 'sbcRemoteReferBehavior', display: 'Remote REFER Mode', selected: true, width: 200 },
    { name: 'sbcRemoteReplacesBehavior', display: 'Remote Replaces Mode', selected: true, width: 200 },
    { name: 'iceMode', display: 'ICE Mode', selected: true, width: 200 },
    { name: 'sipUpdateSupport', display: 'SIP UPDATE Support', selected: true, width: 200 },
    { name: 'remoteReInvite', display: 'Remote re-INVITE', selected: true, width: 200 },
    { name: 'remoteDelayedOfferSupport', display: 'Remote Delayed Offer Support', selected: true, width: 200 },
    { name: 'representationMode', display: 'Remote Representation Mode', selected: true, width: 200 },
    { name: 'remoteHoldFormat', display: 'Remote Hold Format', selected: true, width: 200 }
  ];

  constructor(private ipProfileApiService: IpProfileApiService,
              private snackBarService: SnackBarService,
              private userPrivilege: UserPrivilegeService,
              private logicalConjunctionService: LogicalConjunctionService,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.ipProfileDefinition = this.route.snapshot.data.ipProfileDefinition;

    this.refresh();
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  addItem(): void {
    const ipProfile: any = {
      name: '',
      iceMode: 'disable',
      remoteDelayedOfferSupport: 'supported',
      remoteHoldFormat: 'transparent',
      remoteReInvite: 'supported',
      representationMode: 'according-to-mode',
      sbcMediaSecurityMode: 'as-is',
      sbcRemote3xxBehavior: 'transparent',
      sbcRemoteReferBehavior: 'handle-locally',
      sbcRemoteReplacesBehavior: 'standard',
      sipUpdateSupport: 'supported'
    };

    const dialogRef = this.dialog.open(IpProfileDialogComponent, {
      width: '600px',
      data: {
        isEditMode: false,
        selectedItem: ipProfile,
        ipProfileDefinition: this.ipProfileDefinition
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.ipProfileApiService.addIpProfilesDefinition(result).then(() => {
        dialogRef.close();
        this.snackBarService.display(`"${result.name}" successfully added`);
        this.refresh();
      });
    });
  }

  editItem(): void {
    this.ipProfileApiService.getIpProfileDefinition(this.selection.id).then(ipProfile => {
      const dialogRef = this.dialog.open(IpProfileDialogComponent, {
        width: '600px',
        data: {
          isEditMode: true,
          selectedItem: _.cloneDeep(ipProfile),
          ipProfileDefinition: this.ipProfileDefinition
        }
      });

      dialogRef.componentInstance.onApply.subscribe(result => {

        const editConfDialog = this.dialog.open(ConfirmationDialogComponent, {
          disableClose: true,
          width: '460px',
          data: {
            message: `You are about to edit the IP Profile ${this.selection.name}, this change will affect all the connection that utilize this IP Profile.
         Are you sure you want to proceed?`
          }
        });

        editConfDialog.componentInstance.onApply.subscribe(() => {
          this.ipProfileApiService.editIpProfilesDefinition(result, result.id).then(() => {
            editConfDialog.close();
            dialogRef.close();
            this.snackBarService.display(`"${result.name}" successfully edited`);
            this.refresh();
          });
        });
      });
    });
  }

  removeItem(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '460px',
      data: {
        message: `You are about to delete the IP Profile ${this.selection.name}, this change will affect all the nodes.
         Are you sure you want to proceed?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.ipProfileApiService.deleteIpProfileDefinition(this.selection.id).then(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.selection.name} successfully deleted`);
      });
    });
  }

  restoreToDefault(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '460px',
      data: {
        message: `You are about to restore the IP Profile ${this.selection.name} to the default configuration, this change will affect all the nodes.
         Are you sure you want to proceed?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.ipProfileApiService.restoreIpProfileDefinition(this.selection.id).then(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.selection.name} successfully restored to default`);
      });
    });
  }

  refresh(): void {
    this.loaderService.showMainContainer();
    this.ipProfileApiService.getIpProfilesDefinition().then(data => {
      this.initializeIpProfiles(data);
      this.items = data;
      this.loaderService.hideMainContainer();
    }).catch((error) => {
      this.loaderService.hideMainContainer();
    });
  }

  pageChanged(): void {
    this.refresh();
  }

  isAnySelection(): boolean {
    return  this.selection;
  }

  isDefaultProfile(): boolean {
    return this.selection.defaultProfile;
  }

  openColumnsConfiguration(): void {
    const dialogRef = this.dialog.open(TableColumnsConfigurationDialogComponent, {
      width: '350px',
      data: {
        columns: this.displayedColumns
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      dialogRef.close();
    });
  }

  initializeIpProfiles(ipProfiles): void {
    ipProfiles.forEach(ipProfile => {
      for (const prop in ipProfile) {
        if (!_.isNil(this.ipProfileDefinition[prop])) {
          ipProfile[prop] = this.ipProfileDefinition[prop][ipProfile[prop]];
        }
      }
    });
  }

  onFilter(filter: any): any {
    this.armTable.firstPage();
    this.filter = filter;
  }

}
